
import { computed, defineComponent, ref } from 'vue'
import { SSOJoinRulesRouteNames } from '@/router/routes-names'
import { useSSOJoinRulesModule, SSOJoinRulesListModel } from '@/modules/sso-join-rules'
import { useRouter, useRoute } from 'vue-router'
import useQuasar from 'quasar/src/composables/use-quasar.js';
import { useAPIPagination } from '@/views/_shared/search-list/pagination'
import { SimpleSearchFilter } from '@/views/_shared/search-list/types'
import { FormModelCacheTag, restoreFormModelTo } from '@/modules/_shared/forms'
import ConfirmDeletionDialog from '@/components/_shared/dialogs/confirm-deletion-dialog.vue'
import Uuid from '@/components/_shared/uuid.vue'

export default defineComponent({
    name: 'view-sso-join-rules-list',
    components: { Uuid },
    props: {
        restoreFilters: {
            type: [Boolean, String]
        }
    },
    setup (props) {
        const $q = useQuasar()
        const { getSSOJoinRules, ssoJoinRules, ssoJoinRulesFilter, ssoJoinRulesCount, deleteSSOJoinRule } = useSSOJoinRulesModule()
        const router = useRouter()
        const route = useRoute()

        const ssoJoinRulesColumns = ([
            { name: 'id', label: 'Id', field: 'joinRuleId', sortable: true, align: 'left' },
            { name: 'domain', label: 'Domain', field: 'domain', sortable: true, align: 'left' },
            { name: 'department', label: 'Department', field: 'department', sortable: true, align: 'left' },
            { name: 'companyName', label: 'Company name', field: 'companyName', sortable: true, align: 'left' },
            { name: 'groups', label: 'Groups', field: 'groups', sortable: true, align: 'left' },
            { name: 'organizationName', label: 'Organization', field: 'organizationName', sortable: true, align: 'left' },
            { name: 'agreementName', label: 'Agreement', field: 'agreementName', sortable: true, align: 'left' },
            { name: 'actions', label: 'Actions', field: 'actions', align: 'left' }
        ])

        function onEditSSOJoinRuleRow (evt: PointerEvent | null, props: SSOJoinRulesListModel) {
            router.push({ name: SSOJoinRulesRouteNames.EDIT, params: { id: props.joinRuleId }, query: { page: route.query.page } })
        }

        async function onDeleteSSOJoinRuleRow (props: SSOJoinRulesListModel) {
            $q.dialog({
                component: ConfirmDeletionDialog,
                componentProps: {
                    entityType: 'SSO join rule',
                    identifier: props.joinRuleId,
                    deleteCallback: async function () {
                        await deleteSSOJoinRule(props.joinRuleId)
                    }
                }
            })
        }

        const restoredFilter = { value: '' } as SimpleSearchFilter
        if (props.restoreFilters) {
            restoreFormModelTo(restoredFilter, FormModelCacheTag.SSO_JOIN_RULES_LIST_FILTERS)
        }

        const filter = ref<string>(restoredFilter.value ?? '')
        const currentPage = computed(() => route.query.page === null ? '1' : route.query.page)

        const { loading, pagination, onRequest } = useAPIPagination(ssoJoinRulesFilter, getSSOJoinRules, ssoJoinRulesCount, currentPage, true, FormModelCacheTag.SSO_JOIN_RULES_LIST_FILTERS)

        onRequest({
            filter: filter.value || '',
            pagination: pagination.value
        })
        function splitGroups (groups: string | null) {
            if (groups && typeof groups === 'string') {
                return groups.split(',')
            }
            return []
        }

        return {
            loading,
            onRequest,
            filter,
            SSOJoinRulesRouteNames,
            ssoJoinRules,
            ssoJoinRulesColumns,
            pagination,
            onEditSSOJoinRuleRow,
            onDeleteSSOJoinRuleRow,
            route,
            splitGroups
        }
    }
})
